<template>
  <edit-vehicle />
</template>

<script>
import EditVehicle from "@/components/3pl/Settings/Vehicles/EditVehicle/index";
export default {
  components: {
    EditVehicle,
  },
};
</script>
y<style></style>
